import { render, staticRenderFns } from "./inputbind.vue?vue&type=template&id=41508e01&"
import script from "./inputbind.vue?vue&type=script&lang=js&"
export * from "./inputbind.vue?vue&type=script&lang=js&"
import style0 from "./inputbind.vue?vue&type=style&index=0&id=41508e01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports